module.exports = __webpack_public_path__ + "img/211.00401817.png";